import salesBanner from '@/assets/img/consult.png';
import { Box, Flex, Text, useMantineTheme } from '@mantine/core';

const DiagonalLayout = () => {
  const theme = useMantineTheme();

  return (
    <Flex
      w="100%"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
      }}
      mih={167}
    >
      {/* Left image section */}
      <Box
        pos="relative"
        w="40%"
        p={0}
        m={0}
        style={{
          backgroundImage: `url(${salesBanner})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        {/* Diagonal overlay to create angled divider */}
        <Box
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '25%', // control how deep the diagonal cut goes
            height: '100%',
            background: theme.colors.tertiary[0],
            clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 59% 100%)',
          }}
        />
      </Box>

      {/* Right side with teal background */}
      <Box
        w="60%"
        px={40}
        py={30}
        style={{
          backgroundColor: theme.colors.tertiary?.[0],
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Text
          size="lg"
          fw={500}
          lh={1.5}
          style={{ marginBottom: 12 }}
        >
          Consultations are 15 minute introductory calls
          <br />
          with real humans.
        </Text>

        <Text
          size="lg"
          fw={500}
          lh={1.5}
        >
          Calls are completely{' '}
          <strong
            color={theme.colors.minor[0]}
            style={{ fontStyle: 'italic' }}
          >
            free
          </strong>
          , and help us evaluate
          <br />
          your best path forward.
        </Text>
      </Box>
    </Flex>
  );
};

export default DiagonalLayout;
